import {Option} from 'platform/components';

import {isEmpty, isNil} from 'ramda';

import {Nullish} from 'shared/web';

import {VatRateOption} from '../hooks/useVatRatesOptions';

export const getOptionsFromVatRates = (vatRateOptions: [VatRateOption[]] | Nullish): Option[] => {
  if (isNil(vatRateOptions)) {
    return [];
  }

  const [rates] = vatRateOptions;

  if (isEmpty(rates)) {
    return [];
  }

  return rates.map((vatRateOption) => ({
    label: vatRateOption.fieldLabel,
    value: vatRateOption.type,
  }));
};
